//
// Error codes the sign-in path carries from FastAPI through passport to the login
// modal. Shared by the server and the client so the three hops agree on the string.
//

// Cognito temporarily locks an account after repeated failed sign-ins and then
// rejects the correct password with the same NotAuthorizedException as a wrong one.
// FastAPI's /users/verify_password re-labels that case under this code.
const PASSWORD_ATTEMPTS_EXCEEDED_CODE = 'PasswordAttemptsExceeded'

const PASSWORD_ATTEMPTS_EXCEEDED_MESSAGE = 'Too many failed attempts. Wait a few minutes and try again.'

module.exports = {
  PASSWORD_ATTEMPTS_EXCEEDED_CODE,
  PASSWORD_ATTEMPTS_EXCEEDED_MESSAGE
}
